import {
  Box,
  Container,
  Flex,
  Heading,
  HStack,
  Image,
  Link,
  Text,
  VStack
} from "@chakra-ui/react"

const Footer: React.FC = () => (
  <Box as="footer" bg="gray.100" py={10}>
    <Container maxW="container.sm">
      <Flex
        direction={{ base: "column", md: "row" }}
        align="center"
        justify="space-between"
      >
        {/* Logo Section */}
        <Box mb={{ base: 6, md: 0 }}>
          <Image src="/greenflip_logo.png" alt="GreenFlip" w={120} />
        </Box>

        {/* Links Section */}
        <Flex
          direction={{ base: "column", md: "row" }}
          gap={10}
          textAlign={{ base: "center", md: "left" }}
        >
          <VStack px={10} align={{ base: "center", md: "start" }}>
            <Heading as="h3" size="sm" color="brand.700">
              Company
            </Heading>
            <Link href="/about">About us</Link>
            <Link href="/team">Team</Link>
          </VStack>

          <VStack px={10} align={{ base: "center", md: "start" }}>
            <Heading as="h3" size="sm" color="brand.700">
              Legal
            </Heading>
            <Text color="gray.500" fontSize="sm">Terms &amp; Conditions</Text>
            <Text color="gray.500" fontSize="sm">Privacy policy</Text>
            <HStack gap={4} justify={{ base: "center", md: "start" }}>
              <Link
                href="https://www.linkedin.com/company/greenfliphomes"
                aria-label="GreenFlip on LinkedIn"
              >
                <Image src="/images/linkedin.svg" alt="LinkedIn" h={6} />
              </Link>
            </HStack>
          </VStack>
        </Flex>
      </Flex>

      {/* Copyright Section */}
      <Box borderTop="1px solid" borderColor="gray.300" mt={8} pt={4}>
        <Text textAlign="center" color="gray.600">
          &copy; 2026 GreenFlip
        </Text>
      </Box>
    </Container>
  </Box>
)

export default Footer
